import React, { useEffect, useRef } from 'react';
import { Box } from '@mui/material';

export default function InventoryCategoryCard() {
  const chartRef = useRef(null);
  const initialized = useRef(false);

  useEffect(() => {
    if (initialized.current) return;
    initialized.current = true;

    if (chartRef.current && typeof window.opsCategoryChart !== 'undefined') {
      window.opsCategoryChart.canvas = chartRef.current;
      window.opsCategoryChart.ctx = chartRef.current.getContext('2d');
      document.getElementById('opsCategoryChart').chart = window.opsCategoryChart;
    }
  }, []);

  return (
    <Box className="card" style={{ minHeight: '300px' }}>
      <div className="card-head">
        <h3 className="card-title" id="opsCatTitle">Inventory value by category</h3>
        <span className="click-tag">Click bars for category detail</span>
      </div>
      <div className="chart-wrap" style={{ height: '240px' }}>
        <canvas id="opsCategoryChart" ref={chartRef}></canvas>
      </div>
      <div className="scenario-btns" style={{ marginTop: 12 }}>
        <button className="scenario-btn active" onClick={() => window.opsSetCatMode?.('value', document.querySelector('.scenario-btn.active'))}>Value</button>
        <button className="scenario-btn" onClick={() => window.opsSetCatMode?.('units', document.querySelector('.scenario-btn.active'))}>Units</button>
        <button className="scenario-btn" onClick={() => window.opsSetCatMode?.('pct', document.querySelector('.scenario-btn.active'))}>%</button>
      </div>
    </Box>
  );
}
